module.exports = __webpack_public_path__ + "images/isuzu_small5cbc6ab1a9e01db01781fd25d47ecc18.png";